/** @jsx jsx */
import { gql } from '@apollo/client';
import { SemiTitle } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';
import BrandContact from './BrandContact';

export default function BrandContacts({ brand, ...rest }) {
  if (!hasContent(brand)) return null;
  return (
    <Section {...rest}>
      <SemiTitle sx={{}}>
        <Trans>Contacts</Trans>
      </SemiTitle>
      {brand.brandContacts?.map((contact, index) => (
        <BrandContact key={index} contact={contact} sx={{ paddingBottom: 2 }} />
      ))}
    </Section>
  );
}
function hasContent(brand) {
  if (!brand.brandContacts?.length) return false;
  return brand.brandContacts.some((contact) =>
    BrandContact.hasContent(contact)
  );
}

export const fragment = graphql`
  fragment BrandContacts on Bottlebooks_AbstractBrand {
    brandContacts: contacts {
      ...BrandContact
    }
  }
`;

BrandContacts.fragment = gql`
  fragment BrandContacts on AbstractBrand {
    contacts {
      ...BrandContact
    }
  }
  ${BrandContact.fragment}
`;
